const axios = require('axios');
let axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        //"Access-Control-Allow-Origin": "*",
        //mode: 'cors'

    },
    timeout: 15 * 1000
};
function ExecRequest(url, request) {
    return Request({

        service: process.env.NODE_ENV === 'production'
            ? 'https://online.fconnect.ru/Services/Widget/api'
            : 'https://testonline.fconnect.ru/Services/WidgetTest/api',
        method: "post",
        url: url,
        request: JSON.stringify(request)
    });
}
function ExecRequestAutoComplite(url, request) {
    return Request({
        service: 'https://fconnect.ru/Services/AutoComplete/api/Main',
        method: "post",
        url: url,
        request: JSON.stringify(request)
    });
}
export function CheckIp(token){
    return new Promise(function (resolve, reject) {
        axios.post('https://www.google.com/recaptcha/api/siteverify', JSON.stringify({secret:process.env.VUE_APP_RECAPTCHA_TOKEN,response:token}), axiosConfig)
            .then((response) => {
            console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error);
                resolve({isSuccess:false});
            })
    });
}




function Request( params ) {
    return new Promise(function (resolve, reject) {
        axios.post(params.service + params.url, params.request, axiosConfig)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
            console.log(error);
                resolve({isSuccess:false});
            })
    });

}

export  function createApp(token,client) {
    return ExecRequest(
        "/CallCenter/CreateApplication",
        Object.assign(
            { "token": token },
            client
        )
    );
}
export  function sendSMS(token,phone) {
    return ExecRequest(
        "/WidgetSms/SendSmsConsent",
        Object.assign(
            { "onlineToken": token },
            phone
        )
    );
}

export  function checkSMS( token,code ) {
    return ExecRequest(
        "/WidgetSms/CheckSmsConsent",
        Object.assign(
            { "onlineToken": token },
            code
        )
    );
}
export  function sendApp( token ) {
    return ExecRequest(
        "/CallCenter/SendApplication",
        Object.assign(
            { "onlineToken": token }
        )
    );
}




export  function searchFIO(data) {
    return ExecRequestAutoComplite(
        "/GetFioDaData",
        Object.assign(
            { "fio": data },

        )
    );
}




